import {
  Device,
  IAddImeiPayload,
  IAddImeiResponse,
  ICheckParams,
  IDeleteDevice,
  IParamsUnassignedImeis,
  IResponseUnassignedImeis,
} from '~/utils/interface/device';
import axiosClient from './axiosClient';

const url: string = '/api/devices';

export interface DeviceUpdatePayload {
  imei: string;
  status: string;
  province_id?: number | string;
  ward_id?: number | string;
  note: string;
}

export interface DeviceTransferPayload {
  action: 'transfer' | 'reclaim';
  imeis: string[];
  provinceId?: number | string;
  wardId?: number | string;
  note: string;
}

const deviceApi = {
  getList(params: Record<string, any>) {
    return axiosClient.get('/api/devices/list', { params });
  },
  getUnassignedImeis(params: IParamsUnassignedImeis) {
    return axiosClient.get<IResponseUnassignedImeis>(url + '/unassigned-imeis', { params });
  },
  checkDevice(params: ICheckParams) {
    return axiosClient.get(`/api/device/check`, { params });
  },
  updateDevice(data: Device) {
    return axiosClient.post(`/api/device/update`, data);
  },
  deleteDevice(data: IDeleteDevice) {
    return axiosClient.delete(`/api/device/delete`, { data });
  },
  getByInstallation(id: number) {
    return axiosClient.get(`/api/device/get-by-installation/${id}`);
  },
  getByUserList(username: string) {
    return axiosClient.get(`/api/device/list-by-user/${username}`);
  },
  addImei(data: IAddImeiPayload) {
    return axiosClient.post<IAddImeiResponse>('/api/devices/add-imei', data);
  },
  updateDeviceInfo(data: DeviceUpdatePayload) {
    return axiosClient.put('/api/devices/update-device', data);
  },
  transferDevices(data: DeviceTransferPayload) {
    return axiosClient.put('/api/devices/transfer', data);
  },
  getAvailableCommands() {
    return axiosClient.get('/sapi/v1/Command/available_commands');
  },
  executeCommand(action: string, data: Record<string, string>) {
    return axiosClient.post(`/sapi/v1/Command/${encodeURIComponent(action)}`, data);
  },
};
export default deviceApi;
